/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ event: NonNullable<unknown>, home: NonNullable<unknown>, homeScore: NonNullable<unknown>, away: NonNullable<unknown>, awayScore: NonNullable<unknown>, url: NonNullable<unknown> }} Email_Game_TextInputs */

const th_email_game_text = /** @type {(inputs: Email_Game_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event}

${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}

ติดตามการแข่งขัน: ${i?.url}

คุณได้รับอีเมลนี้เพราะติดตามทีมหรือรายการแข่งขันนี้ เปลี่ยนการแจ้งเตือนได้ในหน้าโปรไฟล์`)
};

const en_email_game_text = /** @type {(inputs: Email_Game_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event}

${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}

Follow the game: ${i?.url}

You are receiving this because you follow this team or event. Change what you receive in your profile.`)
};

const ja_email_game_text = /** @type {(inputs: Email_Game_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event}

${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}

試合を見る: ${i?.url}

このメールは、このチームまたは大会をフォローしているため送信されています。受信設定はプロフィールから変更できます。`)
};

const zh_email_game_text = /** @type {(inputs: Email_Game_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event}

${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}

关注比赛：${i?.url}

你收到这封邮件，是因为关注了该球队或赛事。可在个人资料中更改接收内容。`)
};

const es_email_game_text = /** @type {(inputs: Email_Game_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event}

${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}

Sigue el partido: ${i?.url}

Recibes esto porque sigues a este equipo o evento. Cambia lo que recibes en tu perfil.`)
};

const pt_email_game_text = /** @type {(inputs: Email_Game_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event}

${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}

Acompanhe o jogo: ${i?.url}

Você recebe isto porque segue este time ou evento. Mude o que recebe no seu perfil.`)
};

const id_email_game_text = /** @type {(inputs: Email_Game_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event}

${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}

Ikuti pertandingan: ${i?.url}

Anda menerima ini karena mengikuti tim atau acara tersebut. Ubah yang Anda terima di profil Anda.`)
};

const fr_email_game_text = /** @type {(inputs: Email_Game_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event}

${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}

Suivre le match : ${i?.url}

Vous recevez ceci parce que vous suivez cette équipe ou cet événement. Modifiez ce que vous recevez dans votre profil.`)
};

const tl_email_game_text = /** @type {(inputs: Email_Game_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event}

${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}

Sundan ang laro: ${i?.url}

Natatanggap mo ito dahil sinusundan mo ang team o event na iyon. Baguhin sa profile mo ang natatanggap mo.`)
};

const vi_email_game_text = /** @type {(inputs: Email_Game_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event}

${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}

Theo dõi trận: ${i?.url}

Bạn nhận được thư này vì đang theo dõi đội hoặc sự kiện đó. Đổi những gì bạn nhận trong hồ sơ của bạn.`)
};

const ko_email_game_text = /** @type {(inputs: Email_Game_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event}

${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}

경기 보기: ${i?.url}

해당 팀 또는 이벤트를 팔로우하고 있어 이 메일을 받으셨습니다. 받을 내용은 프로필에서 바꿀 수 있습니다.`)
};

const de_email_game_text = /** @type {(inputs: Email_Game_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event}

${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}

Spiel verfolgen: ${i?.url}

Du bekommst das, weil du diesem Team oder Event folgst. Ändere in deinem Profil, was du bekommst.`)
};

const ru_email_game_text = /** @type {(inputs: Email_Game_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event}

${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}

Следить за матчем: ${i?.url}

Вы получили это письмо, потому что подписаны на эту команду или событие. Что именно получать, меняется в вашем профиле.`)
};

const tr_email_game_text = /** @type {(inputs: Email_Game_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event}

${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}

Maçı takip edin: ${i?.url}

Bu takımı veya etkinliği takip ettiğiniz için bunu alıyorsunuz. Ne alacağınızı profilinizden değiştirin.`)
};

const it_email_game_text = /** @type {(inputs: Email_Game_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event}

${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}

Segui la partita: ${i?.url}

Ricevi questo messaggio perché segui quella squadra o quell'evento. Puoi cambiare cosa ricevere dal tuo profilo.`)
};

const pl_email_game_text = /** @type {(inputs: Email_Game_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event}

${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}

Śledź mecz: ${i?.url}

Dostajesz tę wiadomość, bo obserwujesz tę drużynę lub to wydarzenie. Zmień, co otrzymujesz, w swoim profilu.`)
};

const uk_email_game_text = /** @type {(inputs: Email_Game_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event}

${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}

Стежити за матчем: ${i?.url}

Ви отримали цей лист, бо стежите за цією командою або подією. Змініть, що саме отримувати, у своєму профілі.`)
};

const hi_email_game_text = /** @type {(inputs: Email_Game_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event}

${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}

मैच देखें: ${i?.url}

आपको यह इसलिए मिला क्योंकि आप उस टीम या आयोजन को फ़ॉलो करते हैं। आप क्या पाते हैं, यह अपनी प्रोफ़ाइल में बदलें।`)
};

const ar_email_game_text = /** @type {(inputs: Email_Game_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event}

${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}

تابع المباراة: ${i?.url}

وصلك هذا لأنك تتابع ذلك الفريق أو تلك الفعالية. غيّر ما تتلقاه من ملفك الشخصي.`)
};

const ms_email_game_text = /** @type {(inputs: Email_Game_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event}

${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}

Ikuti perlawanan: ${i?.url}

Anda menerima ini kerana mengikuti pasukan atau acara itu. Ubah apa yang anda terima dalam profil anda.`)
};

const bn_email_game_text = /** @type {(inputs: Email_Game_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event}

${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}

খেলা অনুসরণ করুন: ${i?.url}

আপনি এটি পেয়েছেন কারণ আপনি ওই দল বা আয়োজন অনুসরণ করেন। কী পাবেন তা নিজের প্রোফাইলে বদলান।`)
};

const zh_tw2_email_game_text = /** @type {(inputs: Email_Game_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event}

${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}

關注賽事：${i?.url}

你收到這封信，是因為你追蹤了該球隊或賽事。可在個人資料中變更接收內容。`)
};

const zh_hk2_email_game_text = /** @type {(inputs: Email_Game_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event}

${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}

關注賽事：${i?.url}

你收到這封信，是因為你追蹤了該球隊或賽事。可在個人資料中變更接收內容。`)
};

const ur_email_game_text = /** @type {(inputs: Email_Game_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event}

${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}

میچ دیکھیں: ${i?.url}

یہ آپ کو اس لیے ملا کہ آپ اس ٹیم یا ایونٹ کو فالو کرتے ہیں۔ آپ کیا وصول کرتے ہیں، اپنے پروفائل میں بدلیں۔`)
};

const fa_email_game_text = /** @type {(inputs: Email_Game_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event}

${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}

دنبال کردن بازی: ${i?.url}

این را دریافت کردید چون آن تیم یا رویداد را دنبال می‌کنید. آنچه دریافت می‌کنید را در نمایهٔ خود تغییر دهید.`)
};

const sw_email_game_text = /** @type {(inputs: Email_Game_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event}

${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}

Fuatilia mchezo: ${i?.url}

Unapokea hii kwa sababu unaifuatilia timu au tukio hilo. Badilisha unachopokea kwenye wasifu wako.`)
};

const nl_email_game_text = /** @type {(inputs: Email_Game_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event}

${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}

Volg de wedstrijd: ${i?.url}

Je krijgt dit omdat je dat team of dat evenement volgt. Wijzig in je profiel wat je ontvangt.`)
};

/**
* | output |
* | --- |
* | "{event} {home} {homeScore} – {away} {awayScore} Follow the game: {url} You are receiving this because you follow this team or event. Change what you receive ..." |
*
* @param {Email_Game_TextInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const email_game_text = /** @type {((inputs: Email_Game_TextInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Email_Game_TextInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_email_game_text(inputs)
	if (locale === "ja") return ja_email_game_text(inputs)
	if (locale === "zh") return zh_email_game_text(inputs)
	if (locale === "es") return es_email_game_text(inputs)
	if (locale === "pt") return pt_email_game_text(inputs)
	if (locale === "id") return id_email_game_text(inputs)
	if (locale === "fr") return fr_email_game_text(inputs)
	if (locale === "tl") return tl_email_game_text(inputs)
	if (locale === "vi") return vi_email_game_text(inputs)
	if (locale === "ko") return ko_email_game_text(inputs)
	if (locale === "de") return de_email_game_text(inputs)
	if (locale === "ru") return ru_email_game_text(inputs)
	if (locale === "tr") return tr_email_game_text(inputs)
	if (locale === "it") return it_email_game_text(inputs)
	if (locale === "pl") return pl_email_game_text(inputs)
	if (locale === "uk") return uk_email_game_text(inputs)
	if (locale === "hi") return hi_email_game_text(inputs)
	if (locale === "ar") return ar_email_game_text(inputs)
	if (locale === "ms") return ms_email_game_text(inputs)
	if (locale === "bn") return bn_email_game_text(inputs)
	if (locale === "zh-TW") return zh_tw2_email_game_text(inputs)
	if (locale === "zh-HK") return zh_hk2_email_game_text(inputs)
	if (locale === "ur") return ur_email_game_text(inputs)
	if (locale === "fa") return fa_email_game_text(inputs)
	if (locale === "sw") return sw_email_game_text(inputs)
	if (locale === "nl") return nl_email_game_text(inputs)
	return en_email_game_text(inputs)
});